export type ProfitTrendKey = "cm" | "acq" | "ops" | "pip";

export interface ProfitTrendMonth {
  revenue: number;
  cm: number;
  customers: number;
  newCustomers: number;
  dayOneCm: number;
  firstOrderCommissions: number;
  unallocatedCommissions: number;
  commissions: number;
  adSpend: number;
  overhead: number;
}

/**
 * Recompute one Profit Model lever for a historical month. Historical charts
 * must use the reviewed overhead attached to that month, not today's planning
 * amount. The API already fills missing months with the approved planning
 * amount, so the chart has one month-specific source for both cases.
 */
export function profitTrendValue(
  key: ProfitTrendKey,
  month: ProfitTrendMonth,
  hasTrustedOverhead: boolean,
): number {
  const acquisitionSpend = month.firstOrderCommissions + month.unallocatedCommissions + month.adSpend;
  const wholeBusinessSpend = month.commissions + month.adSpend;

  if (key === "cm") return month.revenue > 0 ? (month.cm / month.revenue) * 100 : 0;
  if (key === "acq") return acquisitionSpend > 0 ? month.dayOneCm / acquisitionSpend : 0;
  if (key === "ops") {
    return hasTrustedOverhead && month.cm > 0
      ? (1 - month.overhead / month.cm) * 100
      : 0;
  }

  const cmPct = month.revenue > 0 ? month.cm / month.revenue : 0;
  return hasTrustedOverhead && cmPct > 0
    ? (month.overhead + wholeBusinessSpend) / cmPct
    : 0;
}
